import feature from "./feature";

class ExternalApi {
   constructor(api, featureFlags, clientShortName, settings) {
      this.api = api;
      this.feataureFlags = featureFlags;
      this.clientShortName = clientShortName;

      if (settings && settings.customTriggerCacheKey) {
         this.identifySecondaryIdsKey = `${this.clientShortName}_${settings.customTriggerCacheKey}_identified_secondary_ids`
         this.identifyEmailsKey = `${this.clientShortName}_${settings.customTriggerCacheKey}_identify_emails`;
      } else {
         this.identifySecondaryIdsKey = `${this.clientShortName}_identified_secondary_ids`
         this.identifyEmailsKey = `${this.clientShortName}_identify_emails`;
      }
   }

   /**
    * @param {string} [email]
    * @param {object|undefined} [meta]
    */
   identifyUserByEmail = (email, meta) => {
      if (email === undefined || typeof email !== 'string') {
         throw new Error("email parameter is undefined or isn't a string");
      }
      if (meta !== undefined && typeof meta !== 'object') {
         throw new Error("meta parameter isn't an object");
      }

         if (!storeEmailIfNotExists(email, this.identifyEmailsKey)) {
            return
         }

      this.api.setUserId(email);
      this.api.sendEvent('identify', meta);
   };

   /**
    * @param {string} [systemName]
    * @param {string} [id]
    * @param {object|undefined} [meta]
    */
   identifyUserBySecondaryId = (systemName, id, meta) => {
      if (systemName === undefined || typeof systemName !== 'string') {
         throw new Error("systemName parameter is undefined or isn't a string");
      }
      if (id === undefined || typeof id !== 'string') {
         throw new Error("id parameter is undefined or isn't a string");
      }
      if (meta !== undefined && typeof meta !== 'object') {
         throw new Error("meta parameter isn't an object");
      }

      const secondaryID = `${systemName}_${id}`;

         if (!storeSecondaryIDIfNotExists(secondaryID, this.identifySecondaryIdsKey)) {
            return
         }

      meta = meta || {};
      meta.identified_by = 'custom_trigger';

      this.api.setSID(secondaryID);
      this.api.sendEvent('identify', meta);
   }

   /**
    * @param {string} [behaviorName]
    * @param {object|undefined} [meta]
    */
   sendOnPageBehavior = (behaviorName, meta) => {
      if (behaviorName === undefined || typeof behaviorName !== 'string') {
         throw new Error("behaviorName parameter is undefined or isn't a string");
      }
      if (meta !== undefined && typeof meta !== 'object') {
         throw new Error("meta parameter isn't an object");
      }

      this.api.sendEvent(behaviorName, meta);
   }

   /**
    * @param {string} [source]
    * @param {object} [meta]
    */
   updateProfileMetadata = (source, meta) => {
      if (source === undefined || typeof source !== 'string') {
         throw new Error("source parameter is undefined or isn't a string");
      }
      if (meta === undefined || typeof meta !== 'object') {
         throw new Error("meta parameter is undefined or isn't an object");
      }

         const deduplicatedMeta = getDeduplicatedMetadataAndResave(meta);
         if (deduplicatedMeta === undefined) {
            return;
         }
         meta = deduplicatedMeta;

      this.api.setMemberUpdateSource(source);
      this.api.sendEvent('member_update', meta);
   }

}

export default ExternalApi;


/**
 * @param {string} [email]
 * @param {string} [key]
 * @returns {boolean} returns true when the email is newly stored (i.e., when it's not found in localStorage).
 * returns false when the email already exists.
 */
function storeEmailIfNotExists(email, key)  {
   const emailsJson =  window.localStorage.getItem(key);
   if (!emailsJson) {
      window.localStorage.setItem(key, JSON.stringify([email]));
      return true;
   }
   const emails = JSON.parse(emailsJson);
   if (!emails.includes(email)) {
      window.localStorage.setItem(key, JSON.stringify([email, ...emails]));
      return true;
   }
   return false;
}

/**
 * @param {string} [sid] secondary ID
 * @param {string} [key]
 * @returns {boolean} returns true when the secondary ID is newly stored (i.e., when it's not found in localStorage).
 * returns false when the secondary ID already exists.
 */
function storeSecondaryIDIfNotExists(sid,key)  {
   const sidsJson = window.localStorage.getItem(key);
   if (!sidsJson) {
      window.localStorage.setItem(key, JSON.stringify([sid]));
      return true;
   }
   const sids = JSON.parse(sidsJson);
   if (!sids.includes(sid)) {
      window.localStorage.setItem(key, JSON.stringify([sid, ...sids]));
      return true;
   }
   return false;
}

const metadata_fields_key = 'metadata_fields';

/**
 * @param {object} [metadata] metadata to update profile
 */
function getDeduplicatedMetadataAndResave(metadata) {
   const metaDataJson = window.localStorage.getItem(metadata_fields_key);
   if (!metaDataJson) {
      window.localStorage.setItem(metadata_fields_key, JSON.stringify(metadata))
      return metadata;
   }
   const metadataDelta = {};
   const savedMetadata = JSON.parse(metaDataJson);
   for (const prop in metadata) {
      if (savedMetadata[prop]) {
         if (savedMetadata[prop] !== metadata[prop]) {
            metadataDelta[prop] = metadata[prop];
         }
      } else {
         metadataDelta[prop] = metadata[prop];
      }
   }
   if (Object.keys(metadataDelta).length) {
      window.localStorage.setItem(metadata_fields_key, JSON.stringify({...savedMetadata, ...metadataDelta}))
      return metadataDelta;
   }
   return undefined;
}
